import React from 'react';
import ReactDOM from 'react-dom';

import './styles/main.min.css';
import './styles/custom.css';
import './styles/styles.css';

import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';

import history from './createHistory';
import store from './configureStore';
import './toastr.css';
import App from 'components/App';
import ScrollToTop from 'components/ScrollToTop';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={store}>
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </ScrollToTop>
      </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement,
);

serviceWorker.unregister();
